import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ActionDialog from "../../ActionDialog";
import { Checkbox, CircularProgress, FormControlLabel, TextField, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { editAgreementCommissionLimit } from "../../../../actions";
import { normalizePercentValue } from "../../../../util";
import { useManagementAction } from "../../../../hooks/useManagementAction";
import LocaleNumberField from "../../LocaleNumberField";

const ChangeCommissionLimit = ({ open, handleCloseDialog, user, fetchUser }) => {
  const { handleManagementAction } = useManagementAction();

  const initialCommissionLimit = normalizePercentValue(user?.contractAgent?.commissionLimit);
  const defaultCommissionLimit = normalizePercentValue(user?.contractAgent?.contractAgentClass?.commissionLimit);
  const [loading, setLoading] = useState(false);
  const [commissionLimit, setCommissionLimit] = useState(() => initialCommissionLimit);
  const [useDefault, setUseDefault] = useState(user.contractAgent.defaultCommissionLimit);

  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const onFinish = () => {
    if (!isMountedRef.current) return;

    setLoading(false);
    handleCloseDialog();
  };

  const handleSubmit = async () => {
    let newLimit = null;
    if (commissionLimit !== null) {
      newLimit = commissionLimit / 100;
    }

    setLoading(true);
    await handleManagementAction({
      body: { editedUserId: user.id, commissionLimit: newLimit },
      managementAction: editAgreementCommissionLimit,
      onComplete: fetchUser,
      onFinish,
      successMessage: "app.edit.sucesfully",
    });
  };

  const handleClose = () => {
    setCommissionLimit(initialCommissionLimit);
    handleCloseDialog();
  };

  useEffect(() => {
    setCommissionLimit(useDefault ? null : initialCommissionLimit);
  }, [useDefault, initialCommissionLimit]);

  return (
    <ActionDialog
      title="app.edit"
      open={open}
      onAccept={handleSubmit}
      onClose={handleClose}
      textConfirm="app.edit"
      maxWidth="xs"
      disableConfirmButton={loading || commissionLimit === ""}
      textToConfirmation={"app.confirm.changeCommissionLimit"}
    >
      <Typography
        variant="caption"
        color="textSecondary"
        paragraph
      >
        <FormattedMessage id="app.contractAgent.comissionPercentage" />
      </Typography>

      <LocaleNumberField
        defaultValue={defaultCommissionLimit}
        disabled={loading || useDefault}
        endAdornment="%"
        fullWidth
        label={"app.manager.limitCommission"}
        min={0}
        max={100}
        value={commissionLimit}
        setValue={setCommissionLimit}
      />
      <FormControlLabel
        disabled={loading}
        control={
          <Checkbox
            checked={useDefault}
            onChange={() => setUseDefault((prev) => !prev)}
            color="primary"
          />
        }
        label={<FormattedMessage id="app.manager.useDefault" />}
      />
      {loading && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <CircularProgress />
        </div>
      )}
    </ActionDialog>
  );
};

export default ChangeCommissionLimit;
